import React from 'react';
import { BookOpenIcon, CircleCheckIcon, CircleXIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { comparisonRows } from '../data/planning';
export function FinalSection() {
  return <>
      <section className="section final ink" id="your-next-session" data-id="element-28" data-mp="2y2aygwfv2zx2">
        <div className="wrap" data-id="element-29" data-mp="332722ukncpc3">
          <div className="final-inner" data-id="element-30" data-mp="331e6mpr51m99">
            <h2 data-id="element-31" data-mp="334jr1rotnzyn">
              Stop starting from scratch.
              <br data-id="element-32" data-mp="2ochw8m1lzx5h" />
              <span className="accent" data-id="element-33" data-mp="2oc87f1savw1d">Start with a session plan.</span>
            </h2>
            <p className="final-intro" data-id="element-34" data-mp="2t519fhwdwq9r">
              Your job is to prepare and lead the group. Kids Activity Club gives you the structure to work from,
              week after week.
            </p>
            <p className="final-kicker" data-id="element-35" data-mp="2jezmwujojfwy">ACTIVITIES · MATERIALS · TIMING · SCRIPTS · RESOURCES · ADAPTATIONS</p>
            <table className="comparison" data-id="element-36" data-mp="25fgqv0457v10">
              <thead data-id="element-37" data-mp="2adi77da6pg8s">
                <tr data-id="element-38" data-mp="2acqcs5sbpok3">
                  <th scope="col" data-id="element-39" data-mp="2ad8jxxgixn6s">PLANNING FROM SCRATCH</th>
                  <th scope="col" data-id="element-40" data-mp="2wdlikh0aavq3">WITH KIDS ACTIVITY CLUB</th>
                </tr>
              </thead>
              <tbody data-id="element-41" data-mp="2rfthoxhnvz9r">
                {comparisonRows.map(row => <tr key={row.before} data-id="element-42" data-mp="35et561tfu84c">
                    <td data-id="element-43" data-mp="35dqhs3vbqnt6">
                      <CircleXIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-44" data-mp="35e07dqcgisyc" />
                      <span data-id="element-45" data-mp="30g83dxyjfgds">{row.before}</span>
                    </td>
                    <td data-id="element-46" data-mp="2cpcjro48jrhm">
                      <CircleCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-47" data-mp="2cqnjncuk8f3g" />
                      <span data-id="element-48" data-mp="28ptzmuk8nkfu">{row.after}</span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
            <div className="final-offer" data-id="element-49" data-mp="2hpgzvd18ek7b">
              <p className="eyebrow" data-id="element-50" data-mp="2hofd4baus99r">Volume 1 package</p>
              <h3 data-id="element-51" data-mp="1tzcvv4k4sifs">13 weekly sessions + all 5 bonuses</h3>
              <div className="price" data-id="element-52" data-mp="1txtfldyh67e0">
                <strong className="price-amount" data-id="element-53" data-mp="1p0t951xpr2md">$27</strong>
                <span className="price-currency" data-id="element-54" data-mp="1p09qtk45ic7t">USD</span>
              </div>
              <p style={{
              fontSize: 12,
              color: '#C5D2DE',
              marginTop: 8
            }} data-id="element-55" data-mp="3p1ztsm2z5ari">
                One payment · Weeks 1–13 · English digital resources
              </p>
            </div>
            <a className="cta" href="#offer-details" data-id="element-56" data-mp="2myal4d9u91i">
              YES, I WANT MY WEEKLY PLANNING READY
            </a>
            <div className="micro-row" data-id="element-57" data-mp="7kzufriiuce1">
              <span data-id="element-58" data-mp="7o4434era0c3">
                <ShieldCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-59" data-mp="3646tlrjqjext" />
                Payment via Stripe
              </span>
              <span data-id="element-60" data-mp="3b3jngw90xm9w">
                <DownloadIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-61" data-mp="3b549fxh9vww5" />
                Digital delivery
              </span>
              <span data-id="element-62" data-mp="3k47tb3o9kgbp">
                <BookOpenIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-63" data-mp="3k4rcsotkbcru" />
                Volume 1 + 5 bonuses
              </span>
            </div>
          </div>
        </div>
      </section>
      <footer className="footer" data-id="element-64" data-mp="zc5xogtjgq7j">
        <div className="footer-brand" data-id="element-65" data-mp="zfjy3jin6pcc">Kids Activity Club</div>
        <p data-id="element-66" data-mp="2ju83kgf018xi">
          <strong data-id="element-67" data-mp="2jv01vyzzdkrh">Your weekly activities, already planned.</strong>
          <br data-id="element-68" data-mp="2fto7zha2qddh" />
          Open the week. Prepare the materials. Lead the play.
        </p>
        <p className="copyright" data-id="element-69" data-mp="2b2o8c49klh7a">© 2026 Kids Activity Club · All rights reserved.</p>
      </footer>
    </>;
}